import React from 'react';
import { FiCheck } from 'react-icons/fi';

import { MainWrapper, Section, Reveal, Button } from '../../shared';
import { getIcon } from '../../shared/icons/iconMap';
import { useSettings } from '../../../context/SettingsContext';

import './ServicePage.scss';

export function ServicePage() {
  const { t } = useSettings();
  const s = t.services;

  return (
    <MainWrapper currentPageName="Services" headerPageText={s.headerTitle} eyebrow={s.eyebrow} intro={s.intro}>
      {/* 1. The monthly model explained */}
      <Section ariaLabel={s.model.eyebrow}>
        <div className="model">
          <Reveal className="model__copy">
            <span className="ds-eyebrow">{s.model.eyebrow}</span>
            <h2>{s.model.title}</h2>
            <p>{s.model.body}</p>
            <ul className="model__list">
              {s.model.list.map((item) => (
                <li key={item}>
                  <FiCheck aria-hidden="true" /> {item}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.1} className="compare">
            <div className="compare__row compare__row--mine">
              <div>
                <span className="compare__tag">{s.compare.mineTag}</span>
                <strong>{s.compare.mineStrong}</strong>
                <p>{s.compare.mineNote}</p>
              </div>
              <span className="compare__badge">{s.compare.badge}</span>
            </div>
            <div className="compare__row compare__row--them">
              <div>
                <span className="compare__tag">{s.compare.themTag}</span>
                <strong>{s.compare.themStrong}</strong>
                <p>{s.compare.themNote}</p>
              </div>
            </div>
            <p className="compare__foot">{s.compare.foot}</p>
          </Reveal>
        </div>
      </Section>

      {/* 2. Tiers by scope */}
      <Section tint ariaLabel={s.tiersTitle}>
        <Reveal>
          <span className="ds-eyebrow">{s.tiersEyebrow}</span>
          <h2 className="section-title">{s.tiersTitle}</h2>
          <p className="ds-lead">{s.tiersLead}</p>
        </Reveal>
        <div className="tiers">
          {t.tiers.map((tier, i) => (
            <Reveal
              key={tier.name}
              delay={i * 0.08}
              className={`tier ds-card ${tier.highlighted ? 'tier--featured' : ''}`}
            >
              {tier.highlighted && <span className="tier__ribbon">{s.ribbon}</span>}
              <h3 className="tier__name">{tier.name}</h3>
              <p className="tier__scope">{tier.scope}</p>
              <div className="tier__price">{tier.price}</div>
              <span className="tier__note">{tier.priceNote}</span>
              <ul className="tier__features">
                {tier.features.map((feat) => (
                  <li key={feat}>
                    <FiCheck aria-hidden="true" /> {feat}
                  </li>
                ))}
              </ul>
              <Button to="/contact" variant={tier.highlighted ? 'primary' : 'secondary'} className="tier__cta">
                {s.tierCta}
              </Button>
            </Reveal>
          ))}
        </div>
      </Section>

      {/* 3. What a build includes */}
      <Section ariaLabel={s.includedTitle}>
        <Reveal>
          <span className="ds-eyebrow">{s.includedEyebrow}</span>
          <h2 className="section-title">{s.includedTitle}</h2>
        </Reveal>
        <div className="features">
          {t.features.map((feature, i) => (
            <Reveal key={feature.title} delay={i * 0.06} className="feature ds-card ds-card--hover">
              <span className="feature__icon">{getIcon(feature.icon)}</span>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </Reveal>
          ))}
        </div>
      </Section>

      {/* Process recap */}
      <Section tint ariaLabel={s.stepsTitle}>
        <Reveal>
          <span className="ds-eyebrow">{s.stepsEyebrow}</span>
          <h2 className="section-title">{s.stepsTitle}</h2>
        </Reveal>
        <ol className="steps">
          {t.process.map((step, i) => (
            <Reveal as="li" key={step.title} delay={i * 0.06} className="steps__item">
              <span className="steps__num">{i + 1}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </Reveal>
          ))}
        </ol>
      </Section>

      {/* CTA */}
      <Section ariaLabel={s.cta.title}>
        <Reveal className="services-cta">
          <h2>{s.cta.title}</h2>
          <p>{s.cta.body}</p>
          <Button to="/contact">{s.cta.button}</Button>
        </Reveal>
      </Section>
    </MainWrapper>
  );
}

export default ServicePage;
